import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "qbe-preview-dialog",
  class: "p-fluid kn-dialog--toolbar--primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-p-0 p-m-0 p-col-12" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('common.preview')), 1)
      ]),
      end: _withCtx(() => [
        _createVNode("i", {
          class: "fa fa-times kn-cursor-pointer",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        })
      ]),
      _: 1
    }),
    _createVNode(_component_DataTable, {
      id: "qbe-preview-datatable",
      class: "p-datatable-sm kn-table",
      first: _ctx.first,
      "onUpdate:first": _cache[2] || (_cache[2] = ($event: any) => (_ctx.first = $event)),
      value: _ctx.rows,
      paginator: true,
      lazy: true,
      rows: 20,
      totalRecords: _ctx.lazyParams.size,
      paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
      currentPageReportTemplate: _ctx.$t('common.table.footer.paginated', { first: '{first}', last: '{last}', totalRecords: '{totalRecords}' }),
      responsiveLayout: "stack",
      breakpoint: "960px",
      scrollable: true,
      scrollHeight: _ctx.QBEPreviewDialogDescriptor.scrollHeight,
      onPage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onPage($event)))
    }, {
      empty: _withCtx(() => [
        _createVNode("div", null, _toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
          return (_openBlock(), _createBlock(_component_Column, {
            class: "kn-truncated",
            field: col.dataIndex,
            header: col.header,
            key: col.field,
            sortable: true
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(col.metawebDateFormat ? _ctx.getFormattedDate(slotProps.data[col.dataIndex], col) : slotProps.data[col.dataIndex]), 1)
            ]),
            _: 2
          }, 1032, ["field", "header"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["first", "value", "totalRecords", "currentPageReportTemplate", "scrollHeight"])
  ]))
}